import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';

import { ToastrService } from 'ngx-toastr';
import { DpTableComponent } from '../../common-component/dp-table/dp-table.component';
import { WishlistService } from '../../services/raintree/Transmission/wishlist.service';
import { SerialNoCellComponent } from '../../table-cell/serial-no-cell.component';
import { ReachUserWishlistRes } from '../../services/raintree/interfaces/wishlist.interface';
import { ImageCellComponent } from '../../table-cell/img-cell.component';
import { LoaderComponent } from '../../common-component/loader/loader.component';
import { DpSuccessMessageComponent } from '../../common-component/dp-success-message/dp-success-message.component';
import { AppConfigService } from '../../services/config/app-config.service';
import { Permissions, PermissionsKey } from '../../enum/permission';
import { PrintService } from '../../services/common/print.service';

@Component({
  selector: 'reach-user-wishlist-dialog',
  standalone: true,
  templateUrl: './reach-user-wishlist-dialog.component.html',
  styleUrls: ['./reach-user-wishlist-dialog.component.scss', '../reach-defaulter.component.scss'],
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    ReactiveFormsModule,
    DpTableComponent,
    ImageCellComponent,
    LoaderComponent,
  ],
})
export class ReachUserWishlistDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _wishlistService: WishlistService,
    private dialog: MatDialog,
    private toaster: ToastrService,
    private _dialogRef: MatDialogRef<ReachUserWishlistDialogComponent>,
    private _appConfig: AppConfigService,
    private printService: PrintService
  ) {}
  reachUserWishlists: any = [];
  // showPrintBtn: boolean = false;
  // permissionArray: any = [];
  printData: any = [];
  isMobile: boolean = false

  public displayColumnData: any = [
    {
      id: 'mem_key',
      name: 'Serial Number',
    },
    {
      id: 'familyCode',
      name: 'Family Code',
    },
    {
      id: 'name',
      name: 'Dikshyarthi Name',
    },
    {
      id: 'ritwikName',
      name: 'Ritwick Name',
    },
    {
      id: 'guardianName',
      name: 'Guardian Name',
    },
    {
      id: 'contactNo',
      name: 'Contact',
    },
    {
      id: 'address',
      name: 'Address',
    },
    {
      id: 'pincode',
      name: 'Pincode',
    },
    {
      id: 'image',
      name: '',
    },
  ];
  columnConfs = {
    image: { cssClass: 'img-wid' },
  };
  cellComponentMap = {
    serialNo: SerialNoCellComponent,
    image: ImageCellComponent,
  };
  isLoading: boolean = false;
  ngOnInit(): void {
    this.isMobile = window.matchMedia("(max-width: 600px)").matches;
    // this.permissionArray = this._appConfig.fetchPermissionv3ByViewName();
    // this.fetchPermissions();
    this.fetchReacWishlistData();
  }
  // fetchPermissions() {
  //   let finalPerm: any = [];
  //   const countryPerm = this.permissionArray['INDIA'];
  //   if (this.data?.selectedState != '' && this.data?.selectedState) {
  //     finalPerm = countryPerm?.allStatesPerm;
  //     const statePerm = countryPerm?.statePerms[this.data?.selectedState];
  //     if (this.data?.selectedDistrict != '' && this.data?.selectedDistrict && statePerm?.districtPerms[this.data?.selectedDistrict]) {
  //       finalPerm = [...finalPerm, ...statePerm?.allDistrictsPerm, ...statePerm?.districtPerms[this.data?.selectedDistrict]];
  //     }
  //   }
  //   this.showPrintBtn = true //finalPerm.includes(Permissions.CanPrintDatum);
  // }
  deleteEntireWishlist() {
    if (this.data.wishlist.type === 'centralizedReach') {
      this._wishlistService
        .deleteReachWishList(this.data.wishlist.id)
        .subscribe({
          next: (response: any) => {
            if (!response.error) {
              this._dialogRef.close();
              const dialogRef = this.dialog.open(DpSuccessMessageComponent, {
                panelClass: 'common-pannel-dialog-container',
                data: {
                  mainHeading: `Deleted Data '${this.data.wishlist.name} sucessfully`,
                  subHeading: `Check existing wishlists in My Wishlist page`,
                  buttonValue: 'Finish',
                },
              });
            }
          },
          error: (error) => this.toaster.error(error),
        });
    } else {
      this._wishlistService.deleteWishList(this.data.wishlist.id).subscribe({
        next: (response: any) => {
          if (!response.error) {
            this._dialogRef.close();
            const dialogRef = this.dialog.open(DpSuccessMessageComponent, {
              panelClass: 'common-pannel-dialog-container',
              data: {
                mainHeading: `Deleted Data '${this.data.wishlist.name} sucessfully`,
                subHeading: `Check existing wishlists in My Wishlist page`,
                buttonValue: 'Finish',
              },
            });
          }
        },
        error: (error) => this.toaster.error(error),
      });
    }
  }
  fetchReacWishlistData() {
    this.isLoading = true;
    this._wishlistService
      .fetchReachUserWishlist(this.data.wishlist.id)
      .subscribe({
        next: (response: ReachUserWishlistRes) => {
          this.reachUserWishlists = response.data;

          if (this.reachUserWishlists.length == 0)
            this.toaster.success('No data found');
          this.isLoading = false;
        },
        error: (error) => this.toaster.error(error),
      });
  }
  printPDF() {
    if (this.reachUserWishlists.length === 0) {
      this.toaster.warning('No data available to print');
      return;
    }
    const header: string = `REACH DEFAULTER | ${this.data.wishlist.name}`;
    const columns = [
      'SERIAL NUMBER',
      'FAMILY CODE',
      'DIKSHYARTHI NAME',
      'RITWICK NAME',
      'GUARDIAN NAME',
      'ADDRESS',
      'PINCODE',
    ];
    const cellStyles: any = {
      0: { cellWidth: 2.5, halign: 'center' },
      1: { cellWidth: 3.0, halign: 'center' },
      2: { cellWidth: 5.0 },
      3: { cellWidth: 5.0 },
      4: { cellWidth: 5.0 },
      5: { cellWidth: 6.0},
      6: { cellWidth: 2.0, halign: 'center'  },
    };

    
    const rows = this.reachUserWishlists.map((user: any) => [
      user?.mem_key,
      user.familyCode,
      user.name,
      user?.ritwikName,
      user.guardianName,
      user.address,
      user.pincode,
    ]);
    const currentDate = new Date().toISOString().split('T')[0];
    const fileName = `${this.data.wishlist.name}_${currentDate}`;
    this.printService.printPdf(
      rows,
      columns,
      header,
      fileName,
      'l',
      'a4',
      true,
      cellStyles
    );
  }
  onCellClick(event: any) {
    this._wishlistService.deleteDataInWishList(event.id).subscribe({
      next: (response: any) => {
        if (!response.error)
          this.dialog.open(DpSuccessMessageComponent, {
            panelClass: 'common-pannel-dialog-container',
            data: {
              mainHeading: `Deleted member data from wishlist`,
              subHeading: `Your can access all wish-lists from the My Wishlist menu on the Reach Defaulter page `,
              buttonValue: 'Finish',
            },
          });
      },
      error: (error) => {
        this.toaster.error(error);
      },
    });
    this._dialogRef.close(true);
  }
}
